import type { IApplicationMonitoringProps } from '@brahma/utils';

export const getInitialMonitoringProps = (): IApplicationMonitoringProps => {
  return {
    guestRoleArn: process.env.NEXT_PUBLIC_GUEST_ARN || '',
    identityPoolId: process.env.NEXT_PUBLIC_IDENTITY_POOL_ID || '',
    endpoint: process.env.NEXT_PUBLIC_RUM_ENDPOINT || '',
    applicationId: process.env.NEXT_PUBLIC_RUM_APPLICATION_ID || '',
    applicationVersion: '1.0.0',
    applicationRegion: process.env.NEXT_PUBLIC_RUM_APPLICATION_REGION || ''
  };
};
